export * from './lib/common-data-access-ga-tagging.module';
export * from './lib/+state/ga-tagging.facade';
